var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "#AD916F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4258 32.25L17.4075 32.2683L17.3882 32.25H15.7428C15.5016 32.2498 15.2703 32.1537 15.0998 31.9831C14.9293 31.8124 14.8335 31.581 14.8335 31.3397V16.6603C14.8352 16.4195 14.9315 16.1891 15.1016 16.0188C15.2718 15.8485 15.5021 15.7519 15.7428 15.75H32.2575C32.7598 15.75 33.1668 16.1579 33.1668 16.6603V31.3397C33.1652 31.5805 33.0688 31.8109 32.8987 31.9812C32.7285 32.1515 32.4982 32.2481 32.2575 32.25H17.4258ZM31.3335 26.75V17.5833H16.6668V30.4167L25.8335 21.25L31.3335 26.75ZM31.3335 29.3423L25.8335 23.8423L19.2592 30.4167H31.3335V29.3423ZM20.3335 23.0833C19.8473 23.0833 19.381 22.8902 19.0371 22.5464C18.6933 22.2025 18.5002 21.7362 18.5002 21.25C18.5002 20.7638 18.6933 20.2975 19.0371 19.9536C19.381 19.6098 19.8473 19.4167 20.3335 19.4167C20.8197 19.4167 21.286 19.6098 21.6299 19.9536C21.9737 20.2975 22.1668 20.7638 22.1668 21.25C22.1668 21.7362 21.9737 22.2025 21.6299 22.5464C21.286 22.8902 20.8197 23.0833 20.3335 23.0833Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/ImageIcon.c10de4a185ce48766e5cdd74320cf6ea.svg";
export { ForwardRef as ReactComponent };